import { render, staticRenderFns } from "./DocumentMetadataManual.vue?vue&type=template&id=cdd1be1a&"
import script from "./DocumentMetadataManual.vue?vue&type=script&lang=js&"
export * from "./DocumentMetadataManual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports